export default __webpack_public_path__ + "static/O0303-20004c22bddd77cab735180683e70f81.png";